import React from 'react';
import Tag from 'core/components/Tag';
import clsx from 'clsx';

type ChecklistStatusCode = 'NotStarted' | 'InProgress' | 'ReadyForApproval' | 'Approved' | string | null | undefined;

type Props = {
  status: ChecklistStatusCode;
  className?: string;
};

const STATUS_MAP: Record<string, { label: string; className: string }> = Object.freeze({
  NotStarted: { label: 'Not Started', className: '!bg-slate-100 !text-slate-600' },
  InProgress: { label: 'In Progress', className: '!bg-blue-100 !text-blue-700' },
  ReadyForApproval: { label: 'Ready for Approval', className: '!bg-amber-100 !text-amber-700' },
  Approved: { label: 'Approved', className: '!bg-emerald-100 !text-emerald-700' },
});

export default function ChecklistStatus({ status, className }: Props) {
  const key = (status ?? '').toString().trim();
  const cfg = STATUS_MAP[key] ?? { label: key || '--', className: '!bg-slate-100 !text-slate-700' };
  return (
    <Tag className={clsx('inline-flex items-center border border-gray-200 !px-3 !py-1 font-semibold', cfg.className, className)}>
      {cfg.label}
    </Tag>
  );
}
